/**
 * @return {number} A unique ID (not universally unique)
 */
let id = 0;
export const generateId = () => ++id;
